// import Modes from "./Modes";

class NEH {
  drawSearchTemplate () {
    /* if ("content" in document.createElement("template")) {
        // alert('Hollla');
        // alert(document.querySelector("template").id);
        // let modes_content = document.querySelector("template#id-search-page-template").content.cloneNode(true);
        // let modes_content;
        if (document.querySelector("#id-search-page-template") != null) {
            document.querySelector("#id-search-page-template").cloneNode(true);
            document.getElementById("id-search-template-modes").classList.add("modes-show");
            // document.getElementById("id-search-template-modes").appendChild(modes_content);
        }
    } */
    if (document.querySelector('#id-search-page-fragment') !== null) {
      document.querySelector('#id-search-page-fragment').cloneNode(true)
      document.getElementById('id-search-page-fragment-modes').classList.add('modes-show')
      document.getElementById('id-napps-search-form-input').focus()
    }
    // return (
    // <Modes modes_id="id-search-template-modes" modes_class="modes-show modes modes-black modes-fullscreen modes-anim-slideup">
    //     SEARCH MODES - HURRAY...
    // </Modes>
    // );
  }

  closeSearchTemplate () {
    if (document.querySelector('#id-search-page-fragment-modes') !== null) {
      document.querySelector('#id-search-page-fragment-modes').classList.remove('modes-show')
    }
  }

  drawNewAppsFormTemplate () {
    if (document.querySelector('#id-new-app-form-fragment') !== null) {
      document.querySelector('#id-new-app-form-fragment').cloneNode(true)
      document.getElementById('id-new-app-form-modes').classList.add('modes-show')
    }
  }

  closeNewAppsFormTemplate () {
    if (document.querySelector('#id-new-app-form-fragment') !== null) {
      document.querySelector('#id-new-app-form-fragment').classList.remove('modes-show')
    }
  }

  drawNewAppsCategoryTemplate () {
    if (document.querySelector('#id-new-app-category-fragment') !== null) {
      document.querySelector('#id-new-app-category-fragment').cloneNode(true)
      document.getElementById('id-new-app-category-modes').classList.add('modes-show')
    }
  }

  closeNewAppsCategoryTemplate () {
    document.querySelector('#id-new-app-category-modes').classList.remove('modes-show')
  }

  drawAppsDetailsTemplate () {
    if (document.querySelector('#id-app-details-fragment') !== null) {
      document.querySelector('#id-app-details-fragment').cloneNode(true)
      document.getElementById('id-app-details-modes').classList.add('modes-show')
    }
  }

  closeAppsDetailsTemplate () {
    if (document.querySelector('#id-app-details-modes') !== null) {
      document.querySelector('#id-app-details-modes').classList.remove('modes-show')
    }
  }
}

export default NEH